export const getFilenameFromUrl = (url: string): string =>
  url.split('/').pop() || '';
